/**
 * Sunday Set buy box — the "View details" sheet on each piece row (13.09.2026).
 *
 * Owner: HC Pixel showed 54 of 72 taps on the set rows (x-set-piece) did nothing — people tap the wallet thumbnail
 * expecting to see the piece. "Anh muốn mình có nút view detail ở đấy — click vào là popup ra chi tiết sản phẩm."
 *
 * Every row in snippets/afroyla-sunday-set-box.liquid now carries [data-sset-view="n"] (the link and the thumb) and a
 * <template data-sset-sheet="n"> that Liquid already filled with the sheet BODY (photos, eyebrow, name, note, why list,
 * details, quote, ship line). This file only owns the shell: overlay + sheet + close + "Add the set" mirror button that
 * clicks the box's own CTA ([data-afl-sset-cta]) so the cart logic stays in afroyla-sunday-set.js.
 * Shell classes and motion = the presell sheet (assets/afroyla-seen-detail-sheet.css), loaded by the product section.
 */
(function () {
  'use strict';

  if (window.__aflSsetSheetInit) return;
  window.__aflSsetSheetInit = true;

  var overlay = null;
  var sheet = null;
  var lastFocus = null;

  function closeSheet() {
    if (!sheet) return;
    var s = sheet;
    var o = overlay;
    sheet = overlay = null;
    s.classList.remove('is-open');
    o.classList.remove('is-open');
    document.documentElement.classList.remove('afl-sheet-lock');
    window.setTimeout(function () {
      s.remove();
      o.remove();
    }, 280);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function openSheet(box, tpl, name) {
    closeSheet();
    overlay = document.createElement('div');
    overlay.className = 'afl-sheet-overlay';
    sheet = document.createElement('div');
    sheet.className = 'afl-sheet afl-sheet--sset';
    sheet.setAttribute('data-hc-section', 'modal'); // HC Pixel role: clicks inside report as modal
    sheet.setAttribute('role', 'dialog');
    sheet.setAttribute('aria-modal', 'true');
    sheet.setAttribute('aria-label', name);

    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'afl-sheet__close';
    close.setAttribute('aria-label', 'Close');
    close.setAttribute('data-hc-el', 'x-sheet-close');
    close.textContent = '×';
    sheet.appendChild(close);
    sheet.appendChild(tpl.content.cloneNode(true));

    // mirror of the box CTA: a convinced reader adds the set from inside the sheet instead of scrolling back
    var cta = box.querySelector('[data-afl-sset-cta]');
    if (cta && !cta.disabled) {
      var add = document.createElement('button');
      add.type = 'button';
      add.className = 'afl-sheet__btn afl-sheet__btn--add';
      add.setAttribute('data-hc-el', 'atc');
      add.textContent = (cta.querySelector('.afl-sset__cta-text') || cta).textContent.trim() + ' — ' + (cta.querySelector('.afl-sset__cta-price') || {}).textContent.replace(/\s+/g, ' ').trim();
      add.addEventListener('click', function () {
        closeSheet();
        cta.click();
      });
      sheet.appendChild(add);
    }
    var back = document.createElement('button');
    back.type = 'button';
    back.className = 'afl-sheet__btn afl-sheet__btn--ghost';
    back.setAttribute('data-hc-el', 'x-sheet-close');
    back.textContent = tpl.getAttribute('data-back') || 'Back to your set';
    sheet.appendChild(back);

    document.body.appendChild(overlay);
    document.body.appendChild(sheet);
    document.documentElement.classList.add('afl-sheet-lock');
    overlay.addEventListener('click', closeSheet);
    close.addEventListener('click', closeSheet);
    back.addEventListener('click', closeSheet);
    sheet.addEventListener('click', function (event) {
      var thumb = event.target.closest('.afl-sheet__thumb');
      if (!thumb) return;
      sheet.querySelector('.afl-sheet__hero').src = thumb.getAttribute('data-big');
      sheet.querySelectorAll('.afl-sheet__thumb').forEach(function (other) {
        other.setAttribute('aria-current', other === thumb ? 'true' : 'false');
      });
    });
    window.requestAnimationFrame(function () {
      if (!sheet) return;
      overlay.classList.add('is-open');
      sheet.classList.add('is-open');
      close.focus();
    });
  }

  document.addEventListener('click', function (event) {
    if (!event.target.closest) return;
    var view = event.target.closest('[data-sset-view]');
    if (!view) return;
    var box = view.closest('[data-afl-sset]');
    var tpl = box && box.querySelector('template[data-sset-sheet="' + view.getAttribute('data-sset-view') + '"]');
    if (!tpl) return;
    event.preventDefault();
    lastFocus = view;
    openSheet(box, tpl, view.getAttribute('aria-label') || 'Details');
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && sheet) closeSheet();
  });
})();
